import { Color } from '@tmh-website/shared/colors';
import StyledTypo from '@tmh-website/styles/typo';
import ButtonIcon from '@tmh-website/ui/ButtonIcon';
import ButtonUiText from '@tmh-website/ui/ButtonUiText';
import { StyledFormElements } from '@tmh-website/ui/FormElements';
import { getScrollbarStylingCss } from '@tmh-website/ui/Scrollbar';
import transparentize from 'polished/lib/color/transparentize';
import styled, { css } from 'styled-components';

export const HeaderContainer = styled.div`
  z-index: 2;
  display: flex;
  flex-direction: column-reverse;
  padding: 12px 16px;
  @media (${props => props.theme.breakpoint.sm.up}) {
    flex-direction: column;
    padding: 20px ${props => props.theme.wrapperPaddingMobile} 18px;
  }
  @media (${props => props.theme.breakpoint.md.up}) {
    padding: 20px ${props => props.theme.wrapperPadding} 18px;
  }
`;

export const IconDesktop = styled.div`
  @media (${props => props.theme.breakpoint.sm.down}) {
    display: none;
  }
`;

export const SearchField = styled(StyledFormElements.Container)`
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 0 3px 0 16px;
  margin-top: 16px;
  @media (${props => props.theme.breakpoint.sm.up}) {
    padding: 0 3px 0 10px;
    margin-top: 0;
    margin-bottom: 16px;
  }

  &:last-child {
    @media (${props => props.theme.breakpoint.sm.down}) {
      margin-top: 4px;
    }
    @media (${props => props.theme.breakpoint.sm.up}) {
      margin-bottom: 4px;
    }
  }

  > svg {
    flex-shrink: 0;
  }
`;

export const XButton = styled(ButtonIcon)`
  margin-right: -6px;
`;

export const ShowAllButton = styled(ButtonUiText)`
  flex-shrink: 0;
  min-height: 34px;
  padding: 4px 16px;
`;

export const ShowAllButtonText = styled.span`
  color: ${props => props.theme.color[Color.Neutral_0_White]} !important;
  @media (${props => props.theme.breakpoint.sm.down}) {
    display: none;
  }
`;

export const ShowAllButtonIcon = styled.div`
  @media (${props => props.theme.breakpoint.sm.up}) {
    display: none;
  }
`;

export const SearchInput = styled.input`
  ${StyledTypo.uiTextCss};
  appearance: none;
  width: 100%;
  min-height: 24px;
  padding: 8px 0;
  color: ${props => props.theme.color[Color.Blue_1000_Deep]};
  background: transparent;
  border: none;
  outline: none;

  &::placeholder {
    color: ${props => transparentize(0.8, props.theme.color[Color.Blue_1000_Deep])};
  }
`;

export const ResultsContainer = styled.div`
  width: 100%;
  max-height: 70dvh;
  padding-top: 10px;
  overflow-y: auto;
  ${getScrollbarStylingCss(Color.Neutral_0_White)};
  @media (${props => props.theme.breakpoint.sm.up}) {
    padding: 0 0 10px;
  }
  @media (${props => props.theme.breakpoint.md.up}) {
    padding: 0 24px 10px;
  }
`;

export const Divider = styled.hr`
  margin: 10px ${props => props.theme.wrapperPaddingMobile};
  border: none;
  border-bottom: 1px solid ${props => props.theme.color[Color.Neutral_300]};
  @media (${props => props.theme.breakpoint.md.up}) {
    margin: 10px ${props => props.theme.wrapperPadding};
  }
`;

export const ResultsFade = styled.div`
  position: sticky;
  bottom: 0;
  width: 100%;
  height: 48px;
  margin-top: -24px;
  pointer-events: none;
  background: linear-gradient(
    to bottom,
    ${props => transparentize(1, props.theme.color[Color.Neutral_0_White])} 20%,
    ${props => props.theme.color[Color.Neutral_0_White]} 100%
  );
`;

export const ErrorMessage = styled(StyledTypo.Typography)<{ $onlyErrorMessage?: boolean }>`
  align-items: center;
  width: 100%;
  min-height: 24px;
  padding: 0 ${props => props.theme.wrapperPaddingMobile};
  margin: 10px 0 0;
  text-align: center;
  @media (${props => props.theme.breakpoint.sm.down}) {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  @media (${props => props.theme.breakpoint.sm.up}) {
    padding: ${props => `20px ${props.theme.wrapperPaddingMobile}`};
    margin: 0;
  }
  @media (${props => props.theme.breakpoint.md.up}) {
    min-height: 105px;
    padding: ${props => `30px ${props.theme.wrapperPadding}`};
  }
`;
